export default __webpack_public_path__ + "static/media/dlz.ef717c76.png";